module.exports = __webpack_public_path__ + "static/media/phone-icon.41a34bca.jpg";